import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import api from '../api/axiosConfig';
import { useAuth } from '../context/AuthContext';

export default function BillOutPage() {
  const { storeId, tableId } = useParams();
  const { state } = useLocation();
  const { isAuthenticated, getAccessToken } = useAuth();

  const [cart, setCart] = useState([]); // should come from a real source later
  const [customerName, setCustomerName] = useState('');
  const [hasDiscount, setHasDiscount] = useState(false);
  const [discountedItems, setDiscountedItems] = useState({});

  const cashier = state?.cashierInfo;
  const table = state?.table;

  const handleToggleItemDiscount = (id) => {
    setDiscountedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const subtotal = cart.reduce((sum, item) => {
    const eligible = hasDiscount && discountedItems[item._id];
    const discountRate = eligible ? 0.20 : 0;
    const itemTotal = item.price * item.qty * (1 - discountRate);
    return sum + itemTotal;
  }, 0);

  const handlePrintBilling = () => {
    // In real case: save state or send to backend for record
    console.log('Printing billing statement...');
    console.log('Customer:', customerName);
    console.log('Discounts:', discountedItems);
    console.log('Cart:', cart);
    alert('Billing statement sent to printer');
  };

  useEffect(() => {
    const fetchCart = async () => {
      if (!isAuthenticated || !getAccessToken()) return;

      try {
        const res = await api.get(`/carts/table/${table?.tableNumber}`);
        const cartItems = res.data.items.map((item) => ({
          _id: item.productId._id,
          name: item.productId.name,
          price: item.price,
          qty: item.quantity,
        }));
        setCart(cartItems);
      } catch (err) {
        console.error('Failed to fetch cart for billing:', err);
      }
    };
  
    if (table?.tableNumber) fetchCart();
  }, [isAuthenticated, table]);
  

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <h1 className="text-2xl font-bold mb-4">Bill Out</h1>
      <p className="text-sm mb-2 text-gray-600">Cashier: {cashier?.name}</p>
      <p className="text-sm mb-4 text-gray-600">Table: {table?.tableNumber}</p>

      <div className="mb-4">
        <label className="block font-medium mb-1">Customer Name</label>
        <input
          type="text"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          className="border px-3 py-2 rounded w-full"
        />
      </div>

      <div className="mb-4 flex items-center gap-3">
        <input
          type="checkbox"
          id="discount"
          checked={hasDiscount}
          onChange={(e) => setHasDiscount(e.target.checked)}
        />
        <label htmlFor="discount">Apply PWD/Senior Discount</label>
      </div>

      <div className="bg-white p-4 rounded shadow mb-6">
        <h2 className="text-lg font-semibold mb-3">Order Summary</h2>
        <ul className="space-y-2">
          {cart.map((item) => {
            const eligible = discountedItems[item._id];
            const discountRate = hasDiscount && eligible ? 0.2 : 0;
            const itemTotal = item.qty * item.price * (1 - discountRate);

            return (
              <li key={item._id} className="flex justify-between items-center">
                <div>
                  <div className="font-medium">{item.name} × {item.qty}</div>
                  {hasDiscount && (
                    <div className="text-sm text-gray-500 flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={!!eligible}
                        onChange={() => handleToggleItemDiscount(item._id)}
                      />
                      <span>Eligible for discount</span>
                    </div>
                  )}
                </div>
                <div>₱{itemTotal.toFixed(2)}</div>
              </li>
            );
          })}
        </ul>
        <div className="border-t mt-4 pt-4 font-semibold flex justify-between">
          <span>Total</span>
          <span>₱{subtotal.toFixed(2)}</span>
        </div>
      </div>

      <button
        onClick={handlePrintBilling}
        className="bg-blue-600 text-white py-2 px-6 rounded"
      >
        Print Billing Statement
      </button>
    </div>
  );
}
